import React from 'react'

// components
import { SocialIconLink } from '@/components/commons/links/SocialIconLink.component'

// styles
import { ButtonComponent } from '@/components/commons/buttons'
import { InputComponent } from '@/components/commons/forms/input/Input.component'
import { ISocialPlatform } from '@/interfaces/socials'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'
import { UserContext } from 'context'
import Image from 'next/image'
import { socialConfigureRemoveButton } from 'styles/v2/pages/profile'
import { helperTextStyle } from './styles/profilePersonalInfo.css'

interface Props {
  selectedSocial: ISocialPlatform
  onCloseForm: () => void
}

export const SocialItemConfigure: React.FC<Props> = ({
  selectedSocial,
  onCloseForm,
}) => {
  const { user, updateUser } = React.useContext(UserContext)
  const [loading, setLoading] = React.useState(false)
  const [username, setUsername] = React.useState('')
  const [followers, setFollowers] = React.useState(0)

  React.useEffect(() => {
    const social = user?.socials.find((s) => s.platform === selectedSocial)
    setUsername(social?.identifier || '')
    setFollowers(social?.audience || 0)
  }, [user?.socials, selectedSocial])

  const onCancel = () => {
    onCloseForm()
  }

  const onSave = async () => {
    const cleanedUsername = username.replace(/[\s@]/g, '')
    const copySocials = [...user.socials]
    const socialIndex = copySocials.findIndex(
      (s) => s.platform === selectedSocial
    )
    if (socialIndex > -1) {
      copySocials[socialIndex].identifier = cleanedUsername
      copySocials[socialIndex].audience = followers
    } else {
      copySocials.push({
        platform: selectedSocial,
        identifier: cleanedUsername,
        audience: followers,
      })
    }
    setLoading(true)
    await updateUser({ socials: copySocials })
    setLoading(false)
    onCloseForm()
  }

  const removeSocial = async () => {
    setLoading(true)
    const copySocials = [...user.socials]
    const existSocial = copySocials.find((s) => s.platform === selectedSocial)
    if (existSocial) {
      const newSocialsFiltered = copySocials.filter(
        (s) => s.platform !== selectedSocial
      )
      await updateUser({ socials: newSocialsFiltered })
    }
    setLoading(false)
    onCloseForm()
  }

  const isUsernameInvalid = username.includes('@')

  return (
    <div className="flex flex-column items-center justify-center relative gap-8">
      <div className={socialConfigureRemoveButton} onClick={removeSocial}>
        <div>
          <Image
            alt={'delete'}
            src={IMAGE_PATHS_V2.icons.commons + 'delete.svg'}
            width={32}
            height={32}
          />
        </div>
      </div>
      <SocialIconLink
        social={selectedSocial}
        username={''}
        filterGray={false}
        size={34}
        onClick={() => null}
      />
      <InputComponent
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        label="Username"
      />
      {isUsernameInvalid && (
        <p className={helperTextStyle}>Do not include @ symbols</p>
      )}
      <InputComponent
        type="number"
        label="Followers"
        onChange={(e) => setFollowers(Number(e.target.value))}
        value={followers}
      />
      <div className="full-w">
        <div className="flex gap-2 full-w mt-20">
          <ButtonComponent
            variation="secondary"
            label="Cancel"
            size="xSmall"
            fullWidth
            onClick={onCancel}
            disabled={loading}
          />
          <ButtonComponent
            label="Save"
            size="xSmall"
            fullWidth
            onClick={onSave}
            loading={loading}
          />
        </div>
      </div>
    </div>
  )
}
